
    @if(!_currencyPurchaseService.loading$()) {
        <ng-container [ngTemplateOutlet]="component_loaded"></ng-container>
    }
    @else {
        <ng-container [ngTemplateOutlet]="component_loading"></ng-container>
    }

    <ng-template #component_loading>
        <corp-loading [corp-label] = "'i18n.app.features.pages.loading.load' | translate"></corp-loading>
    </ng-template>

    <ng-template #component_loaded>
        <form [formGroup]="form!" >
            <div class="grid lg:grid-cols-10 gap-x-10 gap-y-0 items-center">
                <!--i18n:I want to convert -->
                <h3 class="col-span-10 text-white!"> {{ 'i18n.app.features.pages.front-pages.common.fp-order-panel.fp-order-purchase.h3_01' | translate }}: </h3>
                <div class="col-span-4"><ng-container *ngTemplateOutlet="tp_input_amount"></ng-container></div>
                <div class="col-span-6">
                     <div 
                        class="py-[1rem] px-[1rem] text-white  rounded-md flex items-start gap-[5px]"
                            [ngClass]="[
                                _currencyPurchaseService.isAmountAlert$()  ? 'bg-primary-500' : 'bg-secondary-300',
                                _currencyPurchaseService.isAmountAlert$() ? 'border border-primary-800' : 'bg-secondary-500'
                                ]">
                        <i   
                            class=" text-[20px] mt-[2px]"
                            [ngClass]="[_currencyPurchaseService.isAmountAlert$()  ? 'ri-alarm-warning-line' : 'ri-shield-check-line']">
                        </i>

                                <div>
                                    <!-- i18n: The total amount must be between -->
                                    {{ 'i18n.app.features.pages.order.wizard.step_01.summary.alert.div_01_1' | translate }}
                                    <span class="font-semibold">
                                        {{ _currencyPurchaseService.orderApprovalRange$()?.minAmount }}
                                    </span>
                                    <!-- i18n: € and -->
                                    {{ 'i18n.app.features.pages.order.wizard.step_01.summary.alert.div_02' | translate }}
                                    <span class="font-semibold">
                                        {{ _currencyPurchaseService.orderApprovalRange$()?.maxAmount }} €.
                                    </span>
                                </div>
                    </div>

                    <!-- <fp-order-purchase-alert></fp-order-purchase-alert> -->
                     <!-- {{ _currencyPurchaseService.orderApprovalRange$()?.minAmount }}  -->
                </div>

                <!--i18n:I receive -->
                <h3 class="col-span-10 text-white! mt-2">{{ 'i18n.app.features.pages.front-pages.common.fp-order-panel.fp-order-purchase.h3_02' | translate }}:</h3>
                <div class="col-span-4"><ng-container *ngTemplateOutlet="tp_output_amount"></ng-container></div>
                <div class="col-span-6"><ng-container *ngTemplateOutlet="tp_output_currency"></ng-container></div>

                <div class="col-span-4">
                    <div class="grid grid-cols-6 items-center w-full lg:text-[15px] xl:text-md mt-[5px] md:mt-[12px] lg:mt-[20px] xl:mt-[25px] py-[12px] px-[17px] bg-white text-gray-800 rounded-md transition-all font-medium disabled:bg-gray-500 text-center">
                        <!-- i18n:Our rate -->
                        <div class="col-span-2 text-xs">{{ 'i18n.app.features.pages.front-pages.common.fp-order-panel.fp-order-purchase.div_01' | translate }}: </div>
                        <div class="col-span-4 font-semibold text-right">1 € = {{ _currencyPurchaseService.getValue(x=>x.targetCurrency)?.sellRate | formatDecimal }} {{_currencyPurchaseService.getValue(x=>x.targetCurrency)?.code}}</div>

                        <!-- i18n:Minimum denomination available
                        <div class="col-span-5 text-xs text-black">{{ 'i18n.app.features.pages.front-pages.common.fp-order-panel.fp-order-purchase.div_02' | translate }}:</div>
                        <div class="col-span-1 text-black font-semibold text-right">{{_currencyPurchaseService.getValue(x=>x.targetCurrency)?.denominationMin}} {{_currencyPurchaseService.getValue(x=>x.targetCurrency)?.symbol}}</div>  -->
                    </div>
                </div>

                <div class="col-span-6">
                    <!-- [disabled]="_currencyPurchaseService.loadingCurrencyValue$()" -->
                    <!-- doit etre un a et pas button pour routerlink sinon forcage a reload par angular.. -->
                    <a  
                        [routerLink]="isPurchaseDisabled() ? null : ['/order-page']"
                        class="block w-full lg:text-[15px] xl:text-md mt-[5px] md:mt-[12px] lg:mt-[20px] xl:mt-[25px] py-[12px] px-[17px] bg-primary-500 text-white rounded-md transition-all font-medium hover:bg-primary-700 text-center"
                        [ngClass]="{
                            'pointer-events-none opacity-50 cursor-not-allowed': isPurchaseDisabled()
                        }">

                        <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[29px] rtl:md:pr-[29px]">
                            <i class="inline-block material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 !text-[20px] md:!text-xl">
                                shop
                            </i>
                            <!--i18n:Order -->
                            {{ 'i18n.app.features.pages.front-pages.common.fp-order-panel.fp-order-purchase.span_01' | translate }}
                        </span>
                    </a>
                </div>
            </div>

            <ng-template #tp_input_currency>
                <corp-dropdown 
                    corp-readonly
                    [corp-loading]="_currencyPurchaseService.loadingCurrencyValue$()"
                    corp-size="xl"
                    [formControlName]="_currencyPurchaseService.modelNames.sourceCurrency.path"
                    [options]="_currencyPurchaseService.selection$()?.currency!"
                    >
                </corp-dropdown>
            </ng-template>

            <ng-template #tp_input_amount>
                <corp-input-decimal 
                    [decimals]="2"
                    [corp-loading]="_currencyPurchaseService.loadingCurrencyValue$()"
                    corp-size="xl"
                    [formControlName]="_currencyPurchaseService.modelNames.sourceAmount.key"
                    [corp-suffix]="_currencyPurchaseService.getValue(x => x.sourceCurrency)?.code">
                </corp-input-decimal>
            </ng-template>

            <ng-template #tp_output_currency>
                <corp-dropdown 
                    [corp-loading]="_currencyPurchaseService.loadingCurrencyValue$()"
                    corp-size="xl"
                    [formControlName]="_currencyPurchaseService.modelNames.targetCurrency.key"
                    [options]="filteredListTarget()!"
                    >
                </corp-dropdown>
            </ng-template>

            <ng-template #tp_output_amount>
                <corp-input-decimal 
                    [decimals]="2"
                    [corp-loading]="_currencyPurchaseService.loadingCurrencyValue$()"
                    corp-size="xl"
                    [corp-suffix]="_currencyPurchaseService.getValue(x => x.targetCurrency)?.code"
                    [formControlName]="_currencyPurchaseService.modelNames.targetAmount!.path!">
                </corp-input-decimal>
            </ng-template>
        </form>
    </ng-template>